import moment from "moment";
import { useClassroomSessionStore } from "stores/v2/classroomSessionStore";
import { ClassroomDetails } from "@/stores/classroomStore_I";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const generateEndTimes = () => {
	let localStartTime = new Date(); // Now
	let localEndTime = new Date();
	localEndTime.setHours(23, 55, 0, 0); // End of the day

	const localisedMaxEndTime = useClassroomSessionStore.getState().getLocalisedMaxEndTime();
	if (localisedMaxEndTime) {
		localStartTime = localisedMaxEndTime.localStartTime;
		localEndTime = localisedMaxEndTime.localEndTime;
	}

	// Set localStartTime to align with the next 5 minute interval
	localStartTime = moment(localStartTime)
		.add(5 - (localStartTime.getMinutes() % 5), "m")
		.toDate();

	// Set localEndTime to align with the previous 5 minute interval
	localEndTime = moment(localEndTime)
		.add(0 - (localEndTime.getMinutes() % 5), "m")
		.toDate();

	// Get total minutes
	// @ts-expect-error - Leaving as is
	const totalMinutes = (localEndTime - localStartTime) / 60000;
	const totalMinuteBlocks = totalMinutes / 5;

	const endTimes = [];
	for (let minuteBlock = 0; minuteBlock <= totalMinuteBlocks; minuteBlock++) {
		const minuteTime = moment(localStartTime)
			.add(5 * minuteBlock, "m")
			.toDate(); // Add 5 minutes
		const endTimeInt = minuteTime.getHours() * 100 + minuteTime.getMinutes();
		let endTimeStr = moment(minuteTime, "HHmm").format("LT");
		if (endTimeStr[1] === ":") {
			endTimeStr = "0" + endTimeStr;
		}

		/** Integer endTime is purposely pushed into the endTimes list and will only be converted to
		 * "seconds until class expires" when teacher presses the save button. This is to handle the
		 * case wherein the dropdown is open for more than a minute and teacher selects end time of 4:00 PM
		 * but the classroom shows to end at 4:01 PM
		 */
		endTimes.push({ value: endTimeInt, text: endTimeStr });
	}
	return endTimes;
};

/**
 * This is a function that returns tuple object containing parsed classroom information.
 * @returns {tuple with [isActive, Expiry] information about the classroom passed in parameter}
 */
export const classroomActiveInfoV2 = (classroom: ClassroomDetails): [boolean, number | null] => {
	const currentTime = new Date().getTime() / 1000;
	const sessionEndTime = classroom.session?.sessionEndTime;
	if (classroom.session?.isMonitoring) {
		if (sessionEndTime && sessionEndTime > currentTime) {
			return [true, sessionEndTime];
		}
		return [false, 0];
	} else {
		if (sessionEndTime && sessionEndTime > currentTime) {
			return [true, sessionEndTime];
		}
		return [false, null];
	}
};
